// extracted by mini-css-extract-plugin
export default {"root":"type-field-module_root-PJZmC"};